import axios from "axios";
import { create } from "zustand";
import { branchCodes } from "../../ts/branches";
// import { useAxios } from "../../hooks/useAxios";

const API_URL = import.meta.env.DEV
    ? "/api/om-oss/vara-medlemsforetag/"
    : "/om-oss/vara-medlemsforetag/";

export const DEFAULT_ZOOM = 5;

export const useFindOrganizationsMapStore = create((set, get) => ({
    abortController: null,
    suggestions: [],
    suggestionsIsLoading: false,
    setSuggestions: async (inputValue) => {
        const abortController = get().abortController;

        if (abortController) {
            abortController.abort();
        }

        const ac = new AbortController();
        set(() => ({ suggestionsIsLoading: true, abortController: ac }));
        const response = await axios
            .get(`${API_URL}FindSuggestions?&query=${inputValue}`, {
                signal: get().abortController.signal,
            })
            .then((res) => res)
            .catch((error) => {
                return { data: [] };

                throw error;
            });
        set(() => ({
            suggestions: response.data,
            suggestionsIsLoading: false,
            abortController: ac,
        }));
    },
    showSuggestions: true,
    setShowSuggestions: (value) => set(() => ({ showSuggestions: value })),

    organizations: [],
    organizationsLoading: false,
    getOrganizations: async (
        bransch = "",
        inputValue = "",
        fairIsChecked = false,
    ) => {
        const groupOrganizations = (organizations) => {
            const groupedOrganizations = {};
            organizations?.forEach((organization) => {
                if (!organization?.geoLocation) return;

                const key = `${organization?.geoLocation?.latitude}-${organization?.geoLocation?.longitude}`;

                if (!groupedOrganizations[key]) {
                    groupedOrganizations[key] = [];
                }

                groupedOrganizations[key].push(organization);
            });
            return groupedOrganizations ?? {};
        };

        let checkFairIsChecked =
            bransch === "" || bransch === branchCodes.TFVAG
                ? fairIsChecked
                : false;
        set(() => ({
            organizationsLoading: true,
            selectedItem: null,
            isLoading: true,
            organizations: [],
            groupedOrganizations: {},
        }));
        const response = await axios(
            `${API_URL}FindMemberOrganisations?branch=${bransch}&query=${inputValue}&onlyFairtransport=${checkFairIsChecked}&onlyGeo=false`,
        );

        set(() => ({
            organizations: response.data,
            organizationsLoading: false,
            expandendResults: true,
            fairIsChecked: checkFairIsChecked,
            isLoading: false,
            groupedOrganizations: groupOrganizations(response.data.result),
        }));
    },
    setOrganizations: (value) =>
        set(() => ({ organizations: value, expandendResults: false })),

    fairIsChecked: false,
    setFairIsChecked: (value) => set(() => ({ fairIsChecked: value })),

    inputValue: "",
    setInputValue: (value) => set(() => ({ inputValue: value })),

    query: "",
    setQuery: (value) => set(() => ({ query: value })),

    bransch: "",
    setBransch: (value) => set(() => ({ bransch: value })),

    selectedItem: null,
    setSelectedItem: (value) => set(() => ({ selectedItem: value })),

    searchTerm: "",
    setSearchTerm: (value) => set(() => ({ searchTerm: value })),

    showMap: true,
    setShowMap: (value) => set(() => ({ showMap: value })),

    expandendResults: false,
    setExpandendResults: (value) => set(() => ({ expandendResults: value })),

    resetSearch: () =>
        set(() => ({
            inputValue: "",
            branch: "",
            fairIsChecked: false,
            organizations: [],
            showSuggestions: false,
            expandendResults: false,
            mapPosition: {
                lat: 62.3875,
                lng: 16.325556,
            },
        })),

    mapPosition: {
        lat: 62.3875,
        lng: 16.325556,
    },

    resetBranschAndOrganizations: () =>
        set(() => ({ bransch: "", organizations: [] })),
    setMapPosition: (value) => set(() => ({ mapPosition: value })),
    isLoading: false,

    showCardPagination: false,
    setShowCardPagination: (value) =>
        set(() => ({ showCardPagination: value })),

    currentPage: 1,
    setCurrentPage: (value) => set(() => ({ currentPage: value })),

    lastPage: 1,
    setLastPage: (value) => set(() => ({ lastPage: value })),

    markerGroups: [],
    setMarkerGroups: (value) => set(() => ({ markerGroups: value })),

    showIndicators: false,
    setShowIndicators: (value) => set(() => ({ showIndicators: value })),

    groupedOrganizations: {},

    findOrganizationGroup: (organization) => {
        const groupedOrganizations = get().groupedOrganizations;
        const key = `${organization?.geoLocation?.latitude}-${organization?.geoLocation?.longitude}`;
        return groupedOrganizations[key] ?? [];
    },
}));

export const useMapRefStore = create((set) => ({
    mapRef: null,
    setMapRef: (value) => set(() => ({ mapRef: value })),
    resultsContainerRef: null,
    setResultsContainerRef: (value) =>
        set(() => ({ resultsContainerRef: value })),
}));

export const useMapFunctionStore = create((set) => ({}));

export const useElementSizeStore = create((set) => ({
    resultsContainerHeight: null,
    setResultsContainerHeight: (value) =>
        set(() => ({ resultsContainerHeight: value })),
    menuContainerHeight: null,
    setMenuContainerHeight: (value) =>
        set(() => ({ menuContainerHeight: value })),
}));

export const useMapStore = create((set) => ({
    map: null, 
    clusterer: null,
    setClusterer: (value) => set(() => ({ clusterer: value })),

    setMap: (value) => set(() => ({ map: value })),
}));
